export const ROLES =  {
    ADMIN: 2, 
    COLLABORATOR: 1,
    USER: "normal_user"
}